import type { MouseEvent, ReactElement } from 'react'
import React from 'react'

import { useFieldSize } from '@ui-kit/components/formComponents/FieldSizeContext'
import { bgColor, borderColor } from '@ui-kit/styles/colors'

import * as styles from './styles'
import type { WebProps } from './types'

const LARGE_FIELD =
  'h-[52px] [&_input]:h-full [&_input]:text-base [&_input]:placeholder:text-grey-500'

const TextFieldContainer = (props: WebProps): ReactElement => {
  const assistiveTextOrError = props.errorMessage ? props.errorMessage : props.assistiveText
  const hasLabel = props.label !== undefined
  const fieldContainerBorderColor = borderColor({ color: props.borderColor ?? 'grey300' })
  const fieldContainerBackgroundColor = bgColor({ color: props.backgroundColor ?? 'white' })
  const { container, fieldContainer, childrenContainer, label, assistiveText } =
    styles.getTextFieldStyles({
      borderColor: fieldContainerBorderColor,
      bgColor: fieldContainerBackgroundColor,
    })({
      disabled: props.disabled,
      isFocused: props.isFocused,
      isFilled: props.isFilled,
      styleType: props.styleType,
      hasLabel,
      status: props.status,
    })

  const isLarge = useFieldSize() === 'large'
  const focusInput = (event: MouseEvent<HTMLDivElement>) => {
    const input = event.currentTarget.querySelector('input')
    if (input && event.target !== input && !props.disabled) {
      event.preventDefault()
      input.focus()
    }
  }

  return (
    <div className={container()}>
      <div
        className={fieldContainer({ className: isLarge ? LARGE_FIELD : undefined })}
        onMouseDown={isLarge ? focusInput : undefined}
      >
        {hasLabel ? (
          <label className={label()} id={`${props.name}-label`} htmlFor={props.fieldId}>
            {props.label}
          </label>
        ) : null}
        <div className={childrenContainer()}>{props.children}</div>
      </div>
      {assistiveTextOrError && <span className={assistiveText()}>{assistiveTextOrError}</span>}
    </div>
  )
}

export default TextFieldContainer
